(() => {
  if (!customElements.get('wm-mobile-navigation')) {
    customElements.define('wm-mobile-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const toggle = this.querySelector('.wm-mobile-menu-toggle');
        const dialog = this.querySelector('dialog');
        this.dialog = dialog;
        this.desktop = window.matchMedia('(min-width: 750px)');
        toggle.addEventListener('click', () => {
          this.previousOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
          toggle.setAttribute('aria-expanded', 'true');
        }, options);
        this.querySelector('.wm-mobile-menu-close').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const focusable = [...dialog.querySelectorAll('button, a[href], summary')].filter(element => element.getClientRects().length);
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, options);
        dialog.addEventListener('close', () => {
          document.body.style.overflow = this.previousOverflow || '';
          toggle.setAttribute('aria-expanded', 'false');
          if (!this.desktop.matches && this.isConnected) toggle.focus();
        }, options);
        dialog.addEventListener('click', event => {
          if (event.target.closest('a')) dialog.close();
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }, options);
        this.desktop.addEventListener('change', () => {
          if (this.desktop.matches && dialog.open) dialog.close();
        }, options);
      }
      disconnectedCallback() {
        if (this.dialog?.open) {
          this.dialog.close();
          document.body.style.overflow = this.previousOverflow || '';
        }
        this.controller?.abort();
      }
    });
  }
  function init(root) {
    root.querySelectorAll('.wm-editable-nav').forEach(nav => {
      if (nav.dataset.navigationReady) return;
      nav.dataset.navigationReady = 'true';
      const menus = [...nav.querySelectorAll('[data-wm-menu]')];
      const hover = window.matchMedia('(min-width: 750px) and (hover: hover)');
      menus.forEach(menu => {
        const summary = menu.querySelector('summary');
        let timer;
        const open = () => {
          menus.forEach(other => { if (other !== menu) other.open = false; });
          menu.open = true;
        };
        menu.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(menu.open));
          if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
        });
        summary.setAttribute('aria-expanded', String(menu.open));
        summary.addEventListener('click', () => clearTimeout(timer));
        menu.addEventListener('pointerenter', event => {
          clearTimeout(timer);
          if (hover.matches && event.pointerType === 'mouse') timer = setTimeout(open, 120);
        });
        menu.addEventListener('pointerleave', event => {
          clearTimeout(timer);
          if (hover.matches && event.pointerType === 'mouse' && !menu.contains(document.activeElement)) {
            timer = setTimeout(() => { menu.open = false; }, 220);
          }
        });
        menu.addEventListener('focusout', event => {
          if (!menu.contains(event.relatedTarget)) menu.open = false;
        });
        menu.addEventListener('keydown', event => {
          if (event.key === 'Escape' && menu.open) {
            clearTimeout(timer);
            event.preventDefault();
            menu.open = false;
            summary.focus();
          }
        });
      });
      document.addEventListener('pointerdown', event => {
        if (!nav.contains(event.target)) menus.forEach(menu => { menu.open = false; });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
